import React from 'react';
import { Plus, RefreshCw } from 'lucide-react';
import { SidebarFooterProps } from './types';

export const SidebarFooter: React.FC<SidebarFooterProps> = React.memo(({
  isCollapsed,
  isCreatingProject,
  onAddProject
}) => {
  return (
    <div className="p-4 border-t border-slate-100 dark:border-slate-800 space-y-2">
      <button 
        type="button"
        onClick={onAddProject}
        disabled={isCreatingProject}
        className={`flex items-center gap-2 rounded-xl border border-solid transition-all duration-200 active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed bg-slate-50 dark:bg-slate-800 border-slate-200/80 dark:border-slate-800 text-slate-500 dark:text-slate-400 hover:text-indigo-600 hover:bg-white dark:hover:bg-slate-750 hover:border-indigo-200 dark:hover:border-indigo-800 shadow-sm mx-auto group/btn
          ${isCollapsed ? 'w-[50px] h-[50px] justify-center p-0' : 'w-4/5 max-w-[200px] h-[50px] px-4 justify-center'}
        `}
      >
        {isCreatingProject ? (
          <RefreshCw size={14} className="animate-spin" />
        ) : (
          <Plus size={14} className="transition-colors group-hover/btn:text-indigo-600 dark:group-hover/btn:text-indigo-400" />
        )}
        {!isCollapsed && (
          <span className="text-[10px] font-black uppercase tracking-widest">
            {isCreatingProject ? 'Erstelle...' : 'Neues Projekt'}
          </span>
        )}
      </button>
    </div>
  );
});
